module.exports = __webpack_public_path__ + "static/media/Icond-8.b36cdcfd.svg";